// 基础资料-员工列表
export const search = {
  inputs: [
    // 信息列数不多，故不要筛选项区域
  ],
  lines: [
    {
      prop: 'name',
      label: 'Name',
      width: 160
    },
    {
      prop: 'email',
      label: 'Email (signin name)',
      width: 260
    },
    {
      prop: 'roleDesc',
      label: 'Role',
      width: 85
    },
    {
      prop: 'status',
      label: 'Status',
      width: 100
    },
    {
      prop: 'able_login',
      label: 'Signin permit',
      width: 120
    },
    {
      prop: 'created_at',
      label: 'Create Date',
      width: 130
    },
    {
      prop: 'updated_at',
      label: 'Modify Date',
      width: 130
    }
    // 员工资料不需要点击详情进行查看操作，因为信息量少。
  ]
}
// 不提供编辑页面、新增页面。员工一旦新建，编辑的几率几乎没有。新增则在数据库中操作（几率极低，澳洲很少招新人）
export default { search }
